<template>
  <div class="sid-select">
    <!--    <SidbearSettingsGroup-->
    <!--      title="Font Styling"-->
    <!--      active-->
    <!--    >-->
    <!--      <TextEditorMod-->
    <!--        :section="section"-->
    <!--        :config="config"-->
    <!--        :resolutioner="resolutioner"-->
    <!--      />-->
    <!--    </SidbearSettingsGroup>-->

    <!--    <SidbearSettingsGroup title="Security">-->
    <!--      asd-->
    <!--    </SidbearSettingsGroup>-->
  </div>
</template>

<script>
import {mapState} from 'vuex'
// import {EditorMenuBar} from 'tiptap'
import ModMixin from '@/components/mixins/ModMixin'
import SidStyles from '@/components/mixins/SidStyles'
import GlobalStyleTextMixin from '@/components/mixins/GlobalStyleTextMixin'
// import SidFont from '@/components/editor/components/sid-controls/sid-control-pressets/font/SidFont.vue'
// import SidbearSettingsGroup from '@/components/editor/components/SidbearSettingsGroup.vue'
// import SidRangeSlider from '@/components/editor/components/sid-controls/SidRangeSlider.vue'
// import TextEditorMod from '@/components/editor/mods/TextEditorMod.vue'

export default {
  name: 'RichTextMod',
  components: {
    // TextEditorMod,
    // SidRangeSlider,
    // EditorMenuBar,
    // SidFont,
    // SidbearSettingsGroup
  },
  mixins: [
    ModMixin,
    GlobalStyleTextMixin,
    SidStyles
  ],
  data () {
    return {
      tags: [
        { label: 'H1', value: 'h1' },
        { label: 'H2', value: 'h2' },
        { label: 'H3', value: 'h3' },
        { label: 'H4', value: 'h4' },
        { label: 'H5', value: 'h5' },
        { label: 'H6', value: 'h6' },
        { label: 'Paragraph', value: 'p' }
      ]
    }
  },
  computed: {
    ...mapState('editor', {
      editor: state => state.tiptap,
      openedItem: state => state.openedItem
    })
  },
  methods: {
    applyFontFamily (val, commands, selected) {
      const {state} = this.editor
      const empty = state.selection.empty

      if (selected.fontFamily || !empty) {
        return setTimeout(() => commands.fontfamily({fontFamily: val.val}), 100)
      }

      val.apply()
    },
    applyFontWeight (val, commands, selected) {
      const {state} = this.editor
      const empty = state.selection.empty

      if (selected.fontWeight || !empty) {
        return setTimeout(() => commands.fontweight({fontWeight: val.val}), 100)
      }

      val.apply()
    }
  }
}
</script>